// extracted by mini-css-extract-plugin
export default {"reactions":"i2tXDg_3","mobile":"mobile","input":"QkuAUz5T","content":"AXoKqhKx","text":"WR4Ld4Jz"};